var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { getNewGuid } from "@ane/core/lib/utils/CommonStringUtils";
import { g as genErrorMessageParameterInfo, a as genErrorMessageAvailabilityStreamInfo, v as validateOverrideBasicInfo, b as validateParameterInfo, c as validateAvailabilityStreamInfo } from "../../../../../DataSourceFormikSettingsUtils-7b059167.js";
import _ from "lodash";
const convertToOverridePostParams = (props) => {
  var _a;
  let postParams = {
    Version: getNewGuid(),
    WorkspaceId: props.workspaceId,
    IsOverrideDataSource: true,
    Name: (_a = props.name) != null ? _a : "",
    OverrideInfo: {
      OverrideFrom: {
        DataSourceVersion: props.FromVersion,
        DataSourceName: props.FromName
      },
      AvailabilityStreams: props.streamList ? props.streamList.map(({ DataPath, VC, Cluster }) => ({
        DataPath,
        VC,
        Cluster
      })) : [],
      Parameters: props.parameterList ? props.parameterList.map(({ Name, Value, Type, SampleValue }) => ({
        Name,
        Value,
        Type,
        DefaultValue: SampleValue
      })) : []
    }
  };
  return postParams;
};
const DataSourceCreateFormSettings = {
  mapPropsToValues: (props) => {
    const data = props.primaryDataSourceItem.data;
    let parameters = (data == null ? void 0 : data.Parameters) ? data == null ? void 0 : data.Parameters.map(({ Name, Value, Type, DefaultValue }, key) => ({
      Name,
      Value,
      Type,
      SampleValue: DefaultValue,
      delete: null,
      DoNotInherited: false,
      required: {
        Name: "",
        Type: "",
        Value: "",
        SampleValue: ""
      },
      placeholder: void 0
    })) : [];
    parameters = genErrorMessageParameterInfo(parameters);
    let streams = (data == null ? void 0 : data.AvailabilityStreams) ? data.AvailabilityStreams.map(({ DataPath, VC, Cluster }, key) => ({
      DataPath,
      VC,
      Cluster,
      required: {
        DataPath: "",
        VC: "",
        Cluster: ""
      },
      delete: null
    })) : [
      {
        DataPath: "",
        VC: "",
        Cluster: "",
        delete: null,
        required: {
          DataPath: "Required",
          VC: "Required",
          Cluster: "Required"
        }
      }
    ];
    streams = genErrorMessageAvailabilityStreamInfo(streams);
    return {
      name: "",
      parameterList: parameters,
      streamList: streams
    };
  },
  validate: (values, props) => {
    let errors = {};
    errors = validateOverrideBasicInfo(props.FromName, values);
    errors = validateParameterInfo(values, errors);
    errors = validateAvailabilityStreamInfo(values, errors);
    return errors;
  },
  validateOnChange: true,
  validateOnBlur: true,
  handleSubmit: (values, bag) => __async(void 0, null, function* () {
    var _a, _b;
    const filteredParameter = _.filter(values.parameterList, (parameter) => {
      return !!parameter.DoNotInherited;
    });
    (_b = (_a = bag.props).onSubmit) == null ? void 0 : _b.call(_a, {
      workspaceId: bag.props.workspaceId,
      FromName: bag.props.FromName,
      FromVersion: bag.props.FromVersion,
      name: bag.props.FromName + "-" + values.name,
      parameterList: filteredParameter,
      streamList: values.streamList
    });
  })
};
const DataSourceEditFormSettings = {
  mapPropsToValues: (props) => {
    var _a, _b, _c, _d;
    const data = props.defaultDataSource;
    let parameters = data.Parameters ? data.Parameters.map(({ Name, Value, Type, DefaultValue }, key) => ({
      Name,
      Value,
      Type,
      SampleValue: DefaultValue,
      delete: null,
      required: {
        Name: "",
        Type: "",
        Value: "",
        SampleValue: ""
      },
      placeholder: void 0
    })) : [];
    let overrideParameters = ((_a = data.OverrideInfo) == null ? void 0 : _a.Parameters) ? (_b = data.OverrideInfo) == null ? void 0 : _b.Parameters.map(({ Name, Value, Type, DefaultValue }, key) => ({
      Name,
      Value,
      Type,
      SampleValue: DefaultValue,
      DoNotInherited: true,
      delete: null,
      required: {
        Name: "",
        Type: "",
        Value: "",
        SampleValue: ""
      },
      placeholder: void 0
    })) : [];
    _.each(parameters, (item, key) => {
      _.each(overrideParameters, (itemOverride, keyOverride) => {
        if (item.Name === itemOverride.Name) {
          parameters = [
            ...parameters.slice(0, key),
            __spreadValues({}, itemOverride),
            ...parameters.slice(key + 1)
          ];
        }
      });
    });
    parameters = genErrorMessageParameterInfo(parameters);
    let streams = ((_c = data.OverrideInfo) == null ? void 0 : _c.AvailabilityStreams) ? (_d = data.OverrideInfo) == null ? void 0 : _d.AvailabilityStreams.map(({ DataPath, VC, Cluster }, key) => ({
      DataPath,
      VC,
      Cluster,
      required: {
        DataPath: "",
        VC: "",
        Cluster: ""
      },
      delete: null
    })) : [];
    streams = genErrorMessageAvailabilityStreamInfo(streams);
    return {
      name: props.name,
      parameterList: parameters,
      streamList: streams
    };
  },
  validate: (values, props) => {
    let errors = {};
    errors = validateParameterInfo(__spreadProps(__spreadValues({}, values), { parameterList: values.parameterList }), errors);
    errors = validateAvailabilityStreamInfo(__spreadProps(__spreadValues({}, values), { streamList: values.streamList }), errors);
    return errors;
  },
  validateOnChange: true,
  validateOnBlur: true,
  handleSubmit: (values, bag) => __async(void 0, null, function* () {
    const filteredParameter = _.filter(values.parameterList, (parameter) => {
      return !!parameter.DoNotInherited;
    });
    bag.props.savePanel && bag.props.savePanel(__spreadProps(__spreadValues({}, values), { parameterList: filteredParameter }));
  })
};
export {
  DataSourceCreateFormSettings,
  DataSourceEditFormSettings,
  convertToOverridePostParams
};
//# sourceMappingURL=DataSourceCreateFormSettings.js.map
